export const GRADE_LEVELS = [...Array(13).keys()].map((grade) => {
  return {
    label: grade ? String(grade) : "K",
    value: grade,
  };
});

export const MIN_GRADE_RANGE = 0;
export const MAX_GRADE_RANGE = 12;

// Radio-buttons cannot have values that are booleans, so we give them string values
// to later convert when sending to the API or converting API data so that it
// can be translated to the UI.
export const displayFlaggedContentToTeachersAsStringValue =
  "display-flagged-content-to-teachers";
export const blockFlaggedContentFromTeachersAsStringValue =
  "block-flagged-content-from-teachers";

export const TEACHER_VIEW_OPTIONS = [
  {
    label: "Show with advisory message",
    description:
      "Content you flag is visible to teachers with an advisory message that must be acknowledged before they can assign it. \n Students can only view flagged content when assigned by a teacher.",
    valueAsString: displayFlaggedContentToTeachersAsStringValue,
    valueAsBoolean: false,
  },
  {
    label: "Block",
    description:
      "Content you flag is not visible to teachers. Flagged content can't be viewed and it can't be assigned, so students will never see it.",
    valueAsString: blockFlaggedContentFromTeachersAsStringValue,
    valueAsBoolean: true,
  },
];

export const API_ERROR_INDICATING_OVERLAPPING_GRADES =
  '["This user has a group with overlapping grades."]';
